import styled from 'styled-components'
import { colors } from '../../theme'

export const DivTitle = styled.div<{ color: string; size?: number }>`
  font-family: 'Poppins';
  line-height: 150%;
  font-weight: 700;
  margin-bottom: 20px;
  /* 18 telas passam a string literal "black" como cor do titulo. No tema
     escuro isso e preto sobre fundo escuro — invisivel. Traduzimos aqui em vez
     de tocar os 18 call sites, e o prop segue aceitando qualquer cor CSS. */
  color: ${({ color }) => (color === 'black' ? colors.grey900 : color)};
  font-size: ${({ size }) => `${size}px`};
`

export const ContainerTitle = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-right: 10px;
`
